export enum NamesEnum {
  AVANS = 'AVANS',
  FINBAR = 'FINBAR',
  CREDISEND = 'CREDISEND',
  STARFIN = 'STARFIN',
  SUNCREDIT = 'SUNCREDIT',
}
